import LoadingSkeletonContainer from 'ComponentLibrary/src/atoms/LoadingSkeleton/LoadingSkeletonContainer'
import { tokens } from 'ComponentLibrary/style-dictionary/output'

export function TaskAttachmentsLoader() {
    return (
        <LoadingSkeletonContainer
            loadersPattern={[
                { count: 1, height: '40px' },
                { count: 3, height: '60px' },
            ]}
            gap={tokens.SizingSpacing300}
            padding={`${tokens.SizingSpacing200} 0`}
        />
    )
}
